<template>
  <base-container>
    <view class="btn-item">
      <cube-basic-picker />
    </view>

    <view class="btn-item">
      <cube-multi-picker />
    </view>

    <view class="btn-item">
      <cube-subtitle-picker />
    </view>

    <view class="btn-item">
      <cube-update-data-picker />
    </view>
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.btn-item
  margin-bottom 15px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "cube-basic-picker": "./basic-picker",
      "cube-multi-picker": "./multi-picker",
      "cube-subtitle-picker": "./subtitle-picker",
      "cube-update-data-picker": "./update-data-picker"
    }
  }
</script>
